/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

import React from 'react';

const Footer = () => {
  return (
    <footer className='privacy-footer'>
          <a href="https://www.mozilla.org/en-US/privacy/websites/">Mozilla's Website Privacy Notice</a>.
          Turn on <a href='https://support.mozilla.org/en-US/kb/how-do-i-turn-do-not-track-feature'>Do Not Track</a> feature in your browser to disable data collection for this application.
    </footer>
  );
};

export default Footer;
